import React from 'react'
import { Alert as AntAlert } from 'antd'

import './Alert.scss'

const Alert = ({ message, ...subProps }) => {
  return (
    <div className='pan-alert'>
      <AntAlert {...subProps} message={<strong>{message}</strong>} />
    </div>
  )
}

Alert.AntAlert = AntAlert
export default Alert
